import { ProductClassification, ProductDTO, SearchProductsDTO } from 'types';

import { api } from './api';

export const productCatalogApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClassifications: build.query<ProductClassification[], any>({
      query: (queryParams) => {
        return {
          url: `product-catalog/classifications${
            queryParams &&
            '?' +
              new URLSearchParams({
                ...queryParams,
              }).toString()
          }`,
        };
      },
    }),
    getProducts: build.query<ProductDTO[], any>({
      query: ({ classification, ...rest }) => ({
        url: `product-catalog/products/${classification}`,
        params: { ...rest },
      }),
    }),
    searchProducts: build.mutation<SearchProductsDTO, any>({
      query: (search) => ({
        url: 'product-catalog/products/search',
        method: 'POST',
        body: search,
      }),
    }),
  }),
});

export const { useGetProductsQuery, useGetClassificationsQuery, useSearchProductsMutation } = productCatalogApi;
